const formatBusinessLine = (businessLine, possessive = true) => {
  if (!businessLine) {
    return '';
  }

  const formattedBusinessLines = {
    MENS: `Men’s`,
    WOMENS: `Women’s`,
    KIDS: `Kid’s`,
    SHELL: '',
  };

  const formattedBusinessLine = formattedBusinessLines[businessLine];

  if (!possessive) {
    // remove the `s
    return formattedBusinessLine.slice(0, -2);
  }

  return formattedBusinessLine;
};

export default formatBusinessLine;
